// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1670":"4af1b5361ea51657","7164":"7b5b8ba3e360f890"}[chunkId] + ".js";
};